import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_vm.canScheduleModifications ? _c("div", {
    staticClass: "flex justify-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openScheduledLogisticCosts();
      }
    }
  }, [_c("i", {
    staticClass: "far fa-calendar-alt mr-1"
  }), _vm._v(" Scheduled ")])], 1) : _vm._e(), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-container"
  }, [_c("div", {
    staticClass: "search-top-buttons --with-display-mode"
  }, [_c("div", {
    staticClass: "display-mode"
  }, [_c("span", [_vm._v("Display by:")]), _c(VSelect, {
    attrs: {
      solo: "",
      "hide-details": "auto",
      "item-value": "id",
      "item-text": "name",
      items: _vm.displayBy
    },
    on: {
      change: function change($event) {
        return _vm.fetchLogisticCosts();
      }
    },
    model: {
      value: _vm.formSearch.sortBy,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "sortBy", $$v);
      },
      expression: "formSearch.sortBy"
    }
  })], 1), _vm.isSaveAllAvailable ? _c(VBtn, {
    staticClass: "dfwa-btn --small highlight",
    attrs: {
      rounded: true,
      loading: _vm.isSavingAll
    },
    on: {
      click: function click($event) {
        return _vm.saveAll();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-content-save-all")]), _vm._v(" Save all ")], 1) : _vm._e()], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.expeditionMethodList,
      label: "Shipping type",
      "item-value": "id",
      "item-text": "text",
      "hide-details": "auto",
      chips: "",
      "deletable-chips": "",
      clearable: "",
      solo: "",
      multiple: ""
    },
    on: {
      blur: function blur($event) {
        return _vm.fetchLogisticCosts();
      }
    },
    model: {
      value: _vm.formSearch.expeditionMethodsId,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "expeditionMethodsId", $$v);
      },
      expression: "formSearch.expeditionMethodsId"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.listCountries,
      label: "Departure from",
      "item-value": "id_country",
      "item-text": "printable_name",
      "hide-details": "auto",
      chips: "",
      "deletable-chips": "",
      clearable: "",
      solo: "",
      multiple: ""
    },
    on: {
      blur: function blur($event) {
        return _vm.fetchLogisticCosts();
      }
    },
    model: {
      value: _vm.formSearch.countriesDepartureId,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "countriesDepartureId", $$v);
      },
      expression: "formSearch.countriesDepartureId"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.listCountriesArrival,
      label: "Arrival to",
      "item-value": "id_country",
      "item-text": "printable_name",
      "hide-details": "auto",
      chips: "",
      "deletable-chips": "",
      clearable: "",
      solo: "",
      multiple: ""
    },
    on: {
      blur: function blur($event) {
        return _vm.fetchLogisticCosts();
      }
    },
    model: {
      value: _vm.formSearch.countriesArrivalId,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "countriesArrivalId", $$v);
      },
      expression: "formSearch.countriesArrivalId"
    }
  })], 1)])])]), _vm.formSearch.sortBy === 2 || _vm.formSearch.sortBy === 3 ? _c("div", {
    staticClass: "list-actions-admin"
  }, [_vm.formSearch.sortBy === 2 ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.addCountryDeparture(null);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New departure ")], 1) : _vm.formSearch.sortBy === 3 ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.addCountryArrival(null);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New arrival ")], 1) : _vm._e()], 1) : _vm._e(), _vm._l(_vm.firstLevel(), function (first) {
    return _c("div", {
      key: first.id
    }, [_c(VExpansionPanels, {
      attrs: {
        value: _vm.panelExpansions["".concat(first.id)]
      }
    }, [_c(VExpansionPanel, {
      staticClass: "first-expansion-panel rounded",
      attrs: {
        "active-class": "rounded"
      }
    }, [_c(VExpansionPanelHeader, [_vm.formSearch.sortBy === 1 ? _c("div", {
      staticClass: "text-field-with-btn"
    }, [_c("div", [_c("i", {
      class: "fas ".concat(first.faIcon)
    }), _vm._v(" " + _vm._s(first.text) + " "), _c("span", {
      staticClass: "badge badge-number"
    }, [_vm._v(_vm._s(first.count))])]), _c("div", {
      staticClass: "new-button"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: true
      },
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return function () {
            _vm.panelExpansions["".concat(first.id)] = 0;
            _vm.addCountryDeparture({
              expedition_method: first.id
            });
          }.apply(null, arguments);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        small: "",
        dark: ""
      }
    }, [_vm._v("mdi-plus")]), _vm._v(" New departure ")], 1)], 1)]) : _vm._e(), _vm.formSearch.sortBy === 2 ? _c("div", {
      staticClass: "text-field-with-btn"
    }, [_c("div", [_c("span", {
      staticClass: "span-location"
    }, [_vm._v("Departure from")]), _vm._v(" " + _vm._s(first.text) + " "), _c("span", {
      staticClass: "badge badge-number"
    }, [_vm._v(_vm._s(first.count))])]), _c("div", {
      staticClass: "new-button"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: true
      },
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return function () {
            _vm.panelExpansions["".concat(first.id)] = 0;
            _vm.addCountryArrival(first.item);
          }.apply(null, arguments);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        small: "",
        dark: ""
      }
    }, [_vm._v("mdi-plus")]), _vm._v(" New arrival ")], 1)], 1)]) : _vm._e(), _vm.formSearch.sortBy === 3 ? _c("div", {
      staticClass: "text-field-with-btn"
    }, [_c("div", [_c("span", {
      staticClass: "span-location"
    }, [_vm._v("Arrival to")]), _vm._v(" " + _vm._s(first.text) + " "), _c("span", {
      staticClass: "badge badge-number"
    }, [_vm._v(_vm._s(first.count))])]), _c("div", {
      staticClass: "new-button"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: true
      },
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return function () {
            _vm.panelExpansions["".concat(first.id)] = 0;
            _vm.addCountryDeparture(first.item);
          }.apply(null, arguments);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        small: "",
        dark: ""
      }
    }, [_vm._v("mdi-plus")]), _vm._v(" New departure ")], 1)], 1)]) : _vm._e()]), _c(VExpansionPanelContent, _vm._l(_vm.secondLevel(first.id), function (second) {
      return _c("div", {
        key: second.id
      }, [_c(VExpansionPanels, {
        attrs: {
          rounded: "",
          value: _vm.panelExpansions["".concat(first.id, "_").concat(second.id)]
        }
      }, [_c(VExpansionPanel, {
        staticClass: "second-expansion-panel rounded-lg",
        attrs: {
          "active-class": "rounded-lg"
        }
      }, [_c(VExpansionPanelHeader, [_vm.formSearch.sortBy === 1 ? _c("div", {
        staticClass: "text-field-with-btn"
      }, [_c("div", [_c("span", {
        staticClass: "span-location"
      }, [_vm._v("Departure from")]), _vm._v(" " + _vm._s(second.text) + " "), _c("span", {
        staticClass: "badge badge-number"
      }, [_vm._v(_vm._s(second.count))])]), _c("div", {
        staticClass: "new-button"
      }, [_c(VBtn, {
        staticClass: "dfwa-btn --small-2 secondary",
        attrs: {
          rounded: true
        },
        on: {
          click: function click($event) {
            $event.stopPropagation();
            return function () {
              _vm.panelExpansions["".concat(first.id, "_").concat(second.id)] = 0;
              _vm.addCountryArrival(second.item);
            }.apply(null, arguments);
          }
        }
      }, [_c(VIcon, {
        attrs: {
          small: "",
          dark: ""
        }
      }, [_vm._v("mdi-plus")]), _vm._v(" New arrival ")], 1)], 1)]) : _vm._e(), _vm.formSearch.sortBy === 2 ? _c("div", [_c("span", {
        staticClass: "span-location"
      }, [_vm._v("Arrival to")]), _vm._v(" " + _vm._s(second.text) + " "), _c("span", {
        staticClass: "badge badge-number"
      }, [_vm._v(_vm._s(second.count))])]) : _vm._e(), _vm.formSearch.sortBy === 3 ? _c("div", [_c("span", {
        staticClass: "span-location"
      }, [_vm._v("Departure from")]), _vm._v(" " + _vm._s(second.text) + " "), _c("span", {
        staticClass: "badge badge-number"
      }, [_vm._v(_vm._s(second.count))])]) : _vm._e()]), _c(VExpansionPanelContent, _vm._l(_vm.thirdLevel(first.id, second.id), function (third) {
        return _c("div", {
          key: third.id
        }, [_c(VExpansionPanels, {
          attrs: {
            value: _vm.panelExpansions["".concat(first.id, "_").concat(second.id, "_").concat(third.id)]
          }
        }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm.formSearch.sortBy === 1 ? _c("div", {
          staticClass: "text-field-with-btn"
        }, [_c("div", [_c("span", {
          staticClass: "span-location"
        }, [_vm._v("Arrival to")]), _vm._v(" " + _vm._s(third.text) + " "), _c("span", {
          staticClass: "badge badge-number"
        }, [_vm._v(_vm._s(third.count))])])]) : _c("div", {
          staticClass: "text-field-with-btn"
        }, [_c("div", [_c("i", {
          class: "fas ".concat(third.faIcon)
        }), _vm._v(" " + _vm._s(third.text) + " "), _c("span", {
          staticClass: "badge badge-number"
        }, [_vm._v(_vm._s(third.count))])])])]), _c(VExpansionPanelContent, _vm._l(_vm.getUserGroups, function (userGroup) {
          return _c("div", {
            key: userGroup
          }, [_c("div", {
            staticClass: "text-field-with-btn content-user-group"
          }, [_c("div", {
            staticClass: "label-group"
          }, [_vm._v(" " + _vm._s(_vm.listUserGroups.find(function (x) {
            return x.id == userGroup;
          }).name) + " "), userGroup == "HORECA" ? _c("span", [_vm._v("& Wholesaler")]) : _vm._e()]), _vm.areProfessionalsAvailable(userGroup, first, second, third) ? _c("div", {
            staticClass: "add-line-button"
          }, [_c(VBtn, {
            staticClass: "dfwa-btn --small-2 secondary",
            attrs: {
              rounded: true
            },
            on: {
              click: function click($event) {
                $event.stopPropagation();
                return function () {
                  _vm.panelExpansions["".concat(first.id, "_").concat(second.id, "_").concat(third.id)] = 0;
                  _vm.formSearch.sortBy === 1 ? _vm.addNewLine(third.item, userGroup) : _vm.addNewLine(_objectSpread(_objectSpread({}, second.item), {}, {
                    expedition_method: third.id
                  }), userGroup);
                }.apply(null, arguments);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              small: "",
              dark: ""
            }
          }, [_vm._v("mdi-plus")]), _vm._v(" New line ")], 1), _c(VIcon, {
            attrs: {
              small: "",
              dark: ""
            }
          }, [_vm._v("mdi-plus")])], 1) : _vm._e()]), _vm.areProfessionalsAvailable(userGroup, first, second, third) ? _c(VDataTable, {
            staticClass: "elevation-2",
            attrs: {
              headers: _vm.headers,
              items: _vm.dataTable(first.id, second.id, third.id, userGroup),
              "items-per-page": -1,
              "item-class": function itemClass(item) {
                return item.isSaving ? "disabled-group" : "";
              },
              "loading-text": "Loading... Please wait",
              "hide-default-footer": "",
              "disable-sort": ""
            },
            scopedSlots: _vm._u([{
              key: "item.qty_min",
              fn: function fn(_ref) {
                var item = _ref.item;
                return [_c(VTextField, {
                  staticClass: "v-text-field-no-label required",
                  attrs: {
                    placeholder: "0",
                    type: "number",
                    min: "1",
                    rules: [_vm.rules.mustBeGreaterThan0],
                    required: ""
                  },
                  on: {
                    change: function change($event) {
                      return _vm.changeLogisticCost(item);
                    }
                  },
                  model: {
                    value: item.qty_min,
                    callback: function callback($$v) {
                      _vm.$set(item, "qty_min", $$v);
                    },
                    expression: "item.qty_min"
                  }
                })];
              }
            }, {
              key: "item.qty_max",
              fn: function fn(_ref2) {
                var item = _ref2.item;
                return [_c("div", {
                  staticClass: "text-field-with-btn"
                }, [_c(VTextField, {
                  staticClass: "v-text-field-no-label required",
                  attrs: {
                    placeholder: "0",
                    type: "number",
                    min: "1",
                    rules: [_vm.rules.mustBeGreaterThan0],
                    required: ""
                  },
                  on: {
                    change: function change($event) {
                      return _vm.changeLogisticCost(item);
                    }
                  },
                  model: {
                    value: item.qty_max,
                    callback: function callback($$v) {
                      _vm.$set(item, "qty_max", $$v);
                    },
                    expression: "item.qty_max"
                  }
                }), _c("div", [_c(VBtn, {
                  staticClass: "dfwa-btn --small-3 secondary",
                  attrs: {
                    title: "Max",
                    rounded: ""
                  },
                  on: {
                    click: function click($event) {
                      return _vm.changeToQuantityMax(item);
                    }
                  }
                }, [_c(VIcon, {
                  attrs: {
                    dark: "",
                    small: ""
                  }
                }, [_vm._v("mdi-arrow-up-drop-circle")])], 1)], 1)], 1)];
              }
            }, {
              key: "item.eta_min_hours",
              fn: function fn(_ref3) {
                var item = _ref3.item;
                return [_c(VTextField, {
                  staticClass: "v-text-field-no-label required",
                  attrs: {
                    placeholder: "0",
                    type: "number",
                    min: "1",
                    rules: [_vm.rules.mustBeGreaterThan0],
                    required: ""
                  },
                  on: {
                    change: function change($event) {
                      return _vm.changeLogisticCost(item);
                    }
                  },
                  model: {
                    value: item.eta_min_hours,
                    callback: function callback($$v) {
                      _vm.$set(item, "eta_min_hours", $$v);
                    },
                    expression: "item.eta_min_hours"
                  }
                })];
              }
            }, {
              key: "item.eta_max_hours",
              fn: function fn(_ref4) {
                var item = _ref4.item;
                return [_c(VTextField, {
                  staticClass: "v-text-field-no-label",
                  attrs: {
                    placeholder: "",
                    type: "number"
                  },
                  on: {
                    change: function change($event) {
                      return _vm.changeLogisticCost(item);
                    }
                  },
                  model: {
                    value: item.eta_max_hours,
                    callback: function callback($$v) {
                      _vm.$set(item, "eta_max_hours", $$v);
                    },
                    expression: "item.eta_max_hours"
                  }
                })];
              }
            }, {
              key: "item.shipping_price_eur_per_bottle",
              fn: function fn(_ref5) {
                var item = _ref5.item;
                return [_c(VTextField, {
                  staticClass: "v-text-field-no-label required",
                  attrs: {
                    placeholder: "0.00 €",
                    type: "number",
                    min: "0.00",
                    required: ""
                  },
                  on: {
                    change: function change($event) {
                      return _vm.changeLogisticCost(item);
                    }
                  },
                  model: {
                    value: item.shipping_price_eur_per_bottle,
                    callback: function callback($$v) {
                      _vm.$set(item, "shipping_price_eur_per_bottle", $$v);
                    },
                    expression: "item.shipping_price_eur_per_bottle"
                  }
                })];
              }
            }, {
              key: "item.action",
              fn: function fn(_ref6) {
                var item = _ref6.item;
                return [_c("div", {
                  staticClass: "table-actions"
                }, [_c(VBtn, {
                  staticClass: "dfwa-btn --small-2 secondary",
                  attrs: {
                    title: "Save",
                    rounded: "",
                    loading: item.isSaving,
                    disabled: !item.isSaveAvailable
                  },
                  on: {
                    click: function click($event) {
                      return _vm.saveLogisticCost(item);
                    }
                  }
                }, [_c(VIcon, {
                  attrs: {
                    dark: "",
                    small: ""
                  }
                }, [_vm._v("mdi-floppy")])], 1), _c(VBtn, {
                  staticClass: "dfwa-btn --small-2 secondary",
                  attrs: {
                    title: "Remove",
                    rounded: ""
                  },
                  on: {
                    click: function click() {
                      _vm.deleteLogisticCost(item);
                    }
                  }
                }, [_c(VIcon, {
                  attrs: {
                    dark: "",
                    small: ""
                  }
                }, [_vm._v("mdi-delete")])], 1)], 1)];
              }
            }], null, true)
          }) : _c("div", {
            staticStyle: {
              "text-align": "left"
            }
          }, [_c(VAlert, {
            staticClass: "--small mb-4",
            attrs: {
              dense: "",
              outlined: "",
              text: "",
              type: "warning",
              color: "orange"
            }
          }, [_vm._v(" Due to regulations around pricing disclosure in the United States, Professional section is prohibited in this state. ")])], 1)], 1);
        }), 0)], 1)], 1)], 1);
      }), 0)], 1)], 1)], 1);
    }), 0)], 1)], 1)], 1);
  }), _vm.logisticCostDialogShown ? _c("LogisticCostDialog", {
    ref: "logisticCostDialog",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      dialog: _vm.logisticCostDialogShown,
      listCountries: _vm.listCountriesForDialog,
      listStates: _vm.listStatesForDialog,
      title: _vm.titleModal,
      confirm: _vm.addLocation,
      cancel: function cancel() {
        return _vm.showLogisticCostDialog(false);
      }
    }
  }) : _vm._e(), _vm.isScheduledLogisticCostsModalShown ? _c("ScheduledLogisticCostsModal", {
    ref: "ScheduledLogisticCostsModal",
    attrs: {
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      listCountriesArrival: _vm.listCountriesArrival,
      listStatesArrival: _vm.listStatesArrival
    },
    on: {
      closed: _vm.closeScheduledLogisticCosts
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };